import { CartSliceType } from '@common/store/cart/slice';
import { addProductToCart, subtractProductFromCart } from '@common/store/cart/slice';
import { ProductsSliceType } from '@common/store/products/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast } from '@common/store/toasts/slice';
import { isMobile } from '@common/utils';
import Button2 from '@components/Button2';
import SectionHeading from '@components/SectionHeading';
import LChevron1 from '@images/LChevron1.svg';
import Error from '@lib/Error';
import Loading from '@lib/Loading';
import classnames from 'classnames';
import React, { useState } from 'react';

import ProductCard from './ProductCard';

interface ProductListProps {
  cart: CartSliceType;
  products: Record<string, ProductsSliceType>;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  addToast: typeof addToast;
  storeInfo: StoreInfoSliceType;
  type?: string;
  heading?: string;
}

const ProductList: React.FC<ProductListProps> = ({
  cart,
  products,
  addToast,
  storeInfo,
  addProductToCart,
  subtractProductFromCart,
}) => {
  const carouselList = products?.list?.results || []; //carouselList
  const [LeftArrow, SetLeftArrow] = useState(false);
  const [RightArrow, SetRightArrow] = useState(true);

  if (!products?.isFetched) {
    return <Loading />;
  } else if (products?.isFetched && products?.error) {
    return <Error message={products.error} />;
  }

  return (
    <div className="product-showcase-container layout-container container mx-auto py-40 overflow-x-hidden ph-6">
      <div className="pb-20">
        <SectionHeading className={'mb-34 text-center mx-auto'}>{products.title}</SectionHeading>
        <div
          className={classnames('flex flex-row flex-no-wrap overflow-x-auto hideScroll')}
          id={`productList-${products.id}`}
          onScroll={() => {
            const ele = document.getElementById(`productList-${products.id}`);
            let val = 0;
            if (isMobile()) val = 100;
            else val = 200;
            if (ele.scrollLeft > val) SetLeftArrow(true);
            else SetLeftArrow(false);
            ele.scrollWidth - ele.scrollLeft === ele.clientWidth ? SetRightArrow(false) : SetRightArrow(true);
          }}
        >
          {carouselList?.map((product, index) => (
            <div className="ml-20 md:ml-30 md:first:ml-0 justify-between items-center" key={index}>
              <ProductCard
                product={product}
                addProductToCart={addProductToCart}
                subtractProductFromCart={subtractProductFromCart}
                cartProductQuantity={cart.quantityByProductId[product.id] || 0}
                addToast={addToast}
                storeInfo={storeInfo}
              />
            </div>
          ))}
        </div>
        {carouselList?.length > 3 && (
          <div className="relative hidden md:block">
            {LeftArrow && (
              <div className=" absolute left-0 top-0 h-full flex items-center md:-mt-300 lg:-mt-265 ml-18 md:-ml-64 pointer-events-none">
                <button
                  className={classnames('z-40 -mt-26 md:mt-0 rounded-full focus:outline-none pointer-events-auto', {
                    'opcaity-50': !LeftArrow,
                  })}
                  onClick={() => {
                    document.getElementById(`productList-${products.id}`).scrollBy({
                      top: 0,
                      left: isMobile() ? -300 : -1250,
                      behavior: 'smooth',
                    });
                  }}
                >
                  <img src={LChevron1} className="fill-current" />
                </button>
              </div>
            )}
            {RightArrow && (
              <div className=" absolute right-30 top-0 h-full flex items-center  md:-mt-300 lg:-mt-265 mr-18 md:-mr-40 pointer-events-none hidden md:block ">
                <button
                  className={classnames(
                    'z-40 -mr-26 md:-mr-90 -mt-26 md:mt-0 rounded-full focus:outline-none  pointer-events-auto',
                    {
                      'opacity-50': !RightArrow,
                    },
                  )}
                  onClick={() => {
                    document.getElementById(`productList-${products.id}`).scrollBy({
                      top: 0,
                      left: isMobile() ? +300 : +1250,
                      behavior: 'smooth',
                    });
                  }}
                >
                  <img src={LChevron1} className=" fill-current transform -rotate-180" />
                </button>
              </div>
            )}
          </div>
        )}
      </div>
      <Button2 link={'/shop'} text={'View All'} customClass="mx-auto" />
    </div>
  );
};

export default ProductList;
